import React, { useLayoutEffect, useState, useEffect } from "react";
import DataGrid, {
  Column,
  Export,
  Format,
  HeaderFilter,
  Pager,
  Paging,
  Editing,
  SearchPanel,
} from "devextreme-react/data-grid";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { TextBox, CheckBox, SelectBox, DateBox } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { assetService } from "../../../apis/apiServices/Asset";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@iconify/react";
import { AssetStatusService } from "../../../apis/apiServices/AssetStatus";
import { maintenanceService } from "../../../apis/apiServices/Maintenance";

export default function MaintComponent() {
  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Maintenance";
  }, []);
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [isCityModalOpen, setIsCityModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [MaintType, setMaintType] = useState([]);
  const [MaintList, setMaintList] = useState([]);
  const [AssetList, setAssetList] = useState([]);
  const [AssetStatusList, setAssetStatusList] = useState([]);
  const [Checklist, setChecklist] = useState([]);
  const [Maintenance, SetMaintenance] = useState({
    id: 0,
    assetId: 0,
    AssetName: "",
    actionDate: null,
    startDate: null,
    endDate: null,
    maintTypeId: 0,
    maintype: "",
    assignedTo: "",
    StatusId: 0,
    StatusName: "",
    remarks: "",
    isActive: true,
  });

  const getAssetSubGroupList = async () => {
    try {
      const Assetresponse = await assetService.getassetDrop();
      setAssetList(Assetresponse?.data);
      const response = await AssetStatusService.getAssetStatus();
      setAssetStatusList(response?.data);
      const dropresponse = await maintenanceService.getMaintenanceDrop();
      setMaintType(dropresponse?.data);
      const maintresponse = await maintenanceService.getMaintenanceList();
      setMaintList(maintresponse?.data);
    } catch (error) {
      console.log("Error fetching Asset List", error);
    }
  };

  useEffect(() => {
    getAssetSubGroupList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

       const newErrors = {};
    if (!Maintenance.assetId) newErrors.assetId = "Select Asset ";
    if (!Maintenance.actionDate) newErrors.actionDate = "Select Action Date ";
    if (!Maintenance.startDate) newErrors.startDate = "Select Start Date ";   
    if (!Maintenance.maintTypeId)
      newErrors.maintTypeId = "Select Maintenance Type "; 
    if (!Maintenance.StatusId) newErrors.StatusId = "Select Status ";
    
     if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsSubmitted(false);
      return;
    }


    try {
      let body = {
        id: Maintenance.id,
        assetId: Maintenance.assetId,
        actionDate: Maintenance?.actionDate || null,
        startDate: Maintenance?.startDate || null,
        endDate: Maintenance?.endDate || null,
        assignedTo: Maintenance?.assignedTo || "",
        maintTypeId: Maintenance?.maintTypeId || 0,
        StatusId: Maintenance?.StatusId || 0,
        remarks: Maintenance?.remarks || "",
        isActive: Maintenance?.isActive || false,
        ModifiedBy: 0,
      };


      let itemDetailsList = [];



      Checklist.map((item) => {

        itemDetailsList.push({
          id: item.checkId,
          Mainid: 0,
          checkId: item.id,
          remarks: item.remarks || "",

        });
      });

      var request = new Object();
      request.Maintenances = body;
      request.checkLists = itemDetailsList;
      const response = await maintenanceService.addMaintenance(request);

      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setIsSubmitted(false);
        return;
      }

      getAssetSubGroupList();   
      setIsSubmitted(false);

      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        navigate(("/Maint", { replace: true }));
        closeModal();
      });
    } catch (error) {
      console.log(error);
    }
  };

  const openModal = () => {
    setIsCityModalOpen(true);
  };

  const closeModal = () => {
    setIsCityModalOpen(false);
    setIsSubmitted(false);
    setErrors({});
    SetMaintenance({
      id: 0,
      AssetName: "",
      actionDate: null,
      startDate: null,
      assetId: 0,
      name: "",
      uomId: 0,
      isActive: true,
    });
  };
  useEffect(() => {
    if (Maintenance.assetId) {
      const fetchChecklist = async () => {
        try {
          const respon = await maintenanceService.getMaintenanceChecklist(Maintenance.assetId, Maintenance.id);
          setChecklist(respon?.data || []);
        } catch (error) {
          console.error("Error fetching checklist:", error);
        }
      };
      fetchChecklist();
    } else {
      setChecklist([]);
    }
  }, [Maintenance.assetId, Maintenance.id]);

  const handleInputChange = async (e, field) => {
    SetMaintenance((prev) => ({
      ...prev,
      [field]: e.value,
    }));



    if (field === "assetId") {
      const respon = await maintenanceService.getMaintenanceChecklist(e.value, Maintenance.id === undefined ? 0 : Maintenance?.id);
      setChecklist(respon?.data);
    
    }

  };

  const renderStatusCell = ({ value }) => {
    const isActive = value === true;

    return (
      <div>
        <span />
        {isActive ? "Active" : "Inactive"}
      </div>
    );
  };
  const handleRowClick = (e) => {
    SetMaintenance({
      id: e.data.id,
      assetId: e.data.assetId,
      AssetName: e.data.AssetName,
      actionDate: e.data.actionDate,
      startDate: e.data.startDate,
      endDate: e.data.endDate,
      maintTypeId: e.data.mainTypeId,
      maintype: e.data.maintype,
      assignedTo: e.data.assignedTo,
      StatusId: e.data.statusId,
      StatusName: e.data.StatusName,
      remarks: e.data.remarks,
      isActive: e.data.isActive,
    });

  };
  const handledelete = (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Deleted", "", "success");
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  const onCellPrepared = (e) => {
    if (e.rowType === "header") {
      e.cellElement.style.backgroundColor = "#595959"; // #808080
      e.cellElement.style.color = "White";
    } else {
      e.cellElement.style.color = "#353839";
    }
  };
  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={MaintList}
              // columnAutoWidth={true}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              onCellClick={(e) => handleRowClick(e)}
              allowColumnResizing={false}
              allowColumnReordering={true}
              // onCellPrepared={onCellPrepared}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  {
                    location: "before",
                    widget: "dxButton",
                    options: {
                      icon: "plus",
                      text: "Add",
                      hint: "Add",
                      type: "default",
                      stylingMode: "contained",
                      onClick: () => openModal(),
                    },
                  },
                  {
                    location: "before",
                    widget: "dxButton",
                    options: {
                      icon: "refresh",
                      text: "Refresh",
                      hint: "Refresh",
                      type: "default",
                      stylingMode: "outlined",
                      onClick: () => getAssetSubGroupList(),
                    },
                  }
                );
              }}
            >
              <HeaderFilter visible={false} />
              <Column
                width="60px"
                caption={""}
                alignment={"center"}
                cellRender={(cellData) => {
                  return (
                    <span>
                      {/* <Icon
                        className="iconify-size mr-2"
                        title="View"
                        tooltip="View"
                        icon="solar:document-text-outline"
                        style={{ cursor: "pointer" }}
                      /> */}

                      <Icon
                        className="iconify-size mr-2"
                        title="Edit"
                        tooltip="Edit"
                        icon="solar:pen-line-duotone"
                        style={{ cursor: "pointer" }}
                        onClick={() => setIsCityModalOpen(true)}
                      />

                      <Icon
                        className="iconify-size"
                        title="Delete"
                        tooltip="Delete"
                        icon="fluent:delete-32-regular"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => handledelete(e)}
                      />
                    </span>
                  );
                }}
              ></Column>
              <Column
                dataField="assetName"
                caption="Asset Name"
                allowFiltering={false}
                width={"300"}
              />
              <Column
                dataField="actionDate"
                caption="Action Date"
                allowFiltering={false}
                dataType="date"
                format="dd-MMM-yyyy"
                width={"150"}
              />
              <Column
                dataField="startDate"
                caption="Start Date"
                dataType="date"
                format="dd-MMM-yyyy"
                allowFiltering={false}
                width={"150"}
              />
              <Column
                dataField="endDate"
                caption="End Date"
                alignment="left"
                dataType="date"
                format="dd-MMM-yyyy"
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />

              <Export enabled={false} fileName="Vendors" />
            </DataGrid>
          </div>
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={isCityModalOpen}
        className="react-modal custom-modal-large"
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="AssetSubGroup Type Modal"
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            <div className="modal-title">Add/Edit Maintenance Asset</div>
          </div>

          <div className="modal-body">
            <div className="row">
              <div className="col-12 col-sm-6 col-lg-6">
                <div className="form-group">
                  <label>Asset <span className="text-danger">*</span> </label>
                  <SelectBox
                    dataSource={AssetList}
                    displayExpr="name" // adjust according to your object
                    valueExpr="id"
                    searchEnabled={true}
                    searchMode="contains"
                    searchExpr="name"
                    placeholder="Select Asset"
                    value={Maintenance.assetId}
                    onValueChanged={(e) => handleInputChange(e, "assetId")}
                    className={`form-control ${errors.assetId ? "is-invalid" : ""
                      }`}
                  />

                  {errors.assetId && (
                    <div className="error invalid-feedback">{errors.assetId}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-6">
                <div className="form-group">
                  <label>Action Date </label>
                  <DateBox
                    className="form-control "
                    value={Maintenance.actionDate}
                    type="date"
                    placeholder="Select date"
                    displayFormat="dd-MMM-yyyy"
                    pickerType="calendar"
                    onValueChanged={(e) => handleInputChange(e, "actionDate")}
                  ></DateBox>
                  
                  {errors.actionDate && (
                    <div className="text-danger">{errors.actionDate}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="form-group">
                  <label> Start Date <span className="text-danger">*</span> </label>
                  <DateBox
                    value={Maintenance.startDate}
                    type="date"
                    placeholder="Select date"
                    displayFormat="dd-MMM-yyyy"
                    pickerType="calendar"
                    className="form-control "
                    onValueChanged={(e) => handleInputChange(e, "startDate")}
                  ></DateBox>
                     {errors.startDate && (
                    <div className="text-danger">{errors.startDate}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="form-group">
                  <label> End Date </label>
                  <DateBox
                    value={Maintenance.endDate}
                    type="date"
                    placeholder="Select date"
                    displayFormat="dd-MMM-yyyy"
                    pickerType="calendar"
                    className="form-control "
                    onValueChanged={(e) => handleInputChange(e, "endDate")}
                  ></DateBox>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label> Maintenance Type <span className="text-danger">*</span> </label>
                  <SelectBox
                    dataSource={MaintType}
                    displayExpr="name" // adjust according to your object
                    valueExpr="id"
                    placeholder="Select maintenance type"
                    value={Maintenance.maintTypeId}
                    onValueChanged={(e) => handleInputChange(e, "maintTypeId")}
                    className={`form-control ${errors.maintTypeId ? "is-invalid" : ""
                      }`}
                  />
                  {errors.description && (
                    <div className="error invalid-feedback">{errors.maintTypeId}</div>
                  )}
                </div>
              </div>

              {/* <div className="col-lg-12 d-flex justify-content-between ">
             
                <CheckBox
                  text="Is Active"
                  value={Asset.isActive}
                  onValueChanged={(e) => handleInputChange(e, "isActive")}
                />
              </div> */}

              <div className="col-lg-6">
                <div className="form-group">
                  <label>Assigned To </label>
                  <TextBox
                    displayExpr="name" // adjust according to your object
                    valueExpr="id"
                    placeholder="Enter assigned to"
                    value={Maintenance.assignedTo}
                    onValueChanged={(e) => handleInputChange(e, "assignedTo")}
                    className={`form-control ${errors.assignedTo ? "is-invalid" : ""
                      }`}
                  />
                  {errors.description && (
                    <div className="error invalid-feedback">{errors.assignedTo}</div>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Status </label>
                  <SelectBox
                    dataSource={AssetStatusList}
                    displayExpr="name" // adjust according to your object
                    valueExpr="id"
                    placeholder="Select Location"
                    value={Maintenance.StatusId}
                    onValueChanged={(e) => handleInputChange(e, "StatusId")}
                    className={`form-control ${errors.StatusId ? "is-invalid" : ""
                      }`}
                  />
                  {errors.StatusId && (
                    <div className="error invalid-feedback">{errors.StatusId}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-sm-12 col-lg-12">
                <div className="form-group">
                  <label>Remarks </label>
                  <TextBox
                    className={`form-control ${errors.projectCode ? "is-invalid" : ""
                      }`}
                    placeholder="Enter remarks"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={Maintenance.remarks}
                    onValueChanged={(e) => handleInputChange(e, "remarks")}
                  />
                  {errors.description /*  */ && (
                    <div className="error invalid-feedback">{errors.remarks}</div>
                  )}
                </div>
              </div>
              {/* <div className="col-12 col-sm-12 col-lg-12">
                <DataGrid
                  dataSource={Checklist}
                  columnAutoWidth={true}
                  showColumnLines={true}
                  showRowLines={true}
                  showBorders={true}
                  rowAlternationEnabled={false}
                  allowColumnResizing={true}
                  columnResizingMode="widget"
                  height={200}
                  width="100%"
                >
                  <Editing
                    mode="cell"
                    allowUpdating={true}
                    allowDeleting={false}
                    allowAdding={false}
                    editorOptions={false}
                  />
                  <Column
                    dataField="id"
                    caption="id"
                    visible={false}
                    width={80}
                    allowFiltering={false}
                  />
                  <Column
                    dataField="name"
                    allowUpdating={true}
                    allowDeleting={false}
                    allowAdding={false}
                    editorOptions={false}
                  />
                  <Column
                    dataField="remarks"
                    caption="Remarks"
                    allowEditing={true}
                  />
                  <Column
                    dataField="checkId"
                    caption="checkId"
                    visible={false}
                    allowEditing={true}
                  />
                  <Paging defaultPageSize={15} />
                  <Pager displayMode="compact" showInfo={true} visible={true} />
                </DataGrid>
              </div> */}
            </div>
          </div>



          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeModal}
              title="Cancel"
            >
              <i className="fas fa-times"></i> Cancel
            </button>
            <button type="submit" className="btn btn-primary btn-sm">
              {isSubmitted ? (
                <span title="In process">
                  <i className="fas fa-spinner fa-spin"></i> In process
                </span>
              ) : (
                <span title="Submit">
                  <i className="fas fa-check"></i> Submit
                </span>
              )}
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
